<div
  class="munily-notification-card"
  role="button"
  tabindex="0"
  [attr.aria-disabled]="disabled"
  (click)="onSelect()"
>
  <div class="munily-notification-card__header">
    <div class="munily-notification-card__left">
      <div class="munily-notification-card__icon-container" aria-hidden="true">
        <mat-icon [class]="iconSet">{{ leadingIcon }}</mat-icon>
      </div>

      <div class="munily-notification-card__labels">
        <p class="munily-notification-card__title">{{ title }}</p>
        <p class="munily-notification-card__subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <div class="munily-notification-card__right" (click)="$event.stopPropagation()">
      <common-toggle
        *ngIf="type === 'toggle'; else iconType"
        [checked]="checked"
        [disabled]="disabled"
        [label]="''"
        (change)="onToggleChange($event)"
      ></common-toggle>

      <ng-template #iconType>
        <mat-icon class="munily-notification-card__chevron material-symbols-rounded" aria-hidden="true">
          arrow_forward_ios
        </mat-icon>
      </ng-template>
    </div>
  </div>

  <div class="munily-notification-card__footer" *ngIf="showFooter && footer">
    <p class="munily-notification-card__footer-label">{{ footer.label }}</p>
    <p class="munily-notification-card__footer-value">{{ footer.value }}</p>
  </div>
</div>

